import { Badge } from '@/components/ui/badge'
import { readableTextColor } from '@/lib/contrast'
import { cn } from '@/lib/utils'

interface CategoryBadgeProps {
	name: string
	color: string
	className?: string
}

export function CategoryBadge({ name, color, className }: CategoryBadgeProps) {
	const fg = readableTextColor(color)
	return (
		<Badge
			variant="default"
			className={cn('border-transparent', className)}
			style={{ backgroundColor: color, color: fg }}
		>
			{name}
		</Badge>
	)
}
